const actions = {
    // Movement
    REHYDRATE_MOVEMENT_STATE_SUCCESS: "REHYDRATE_MOVEMENT_STATE_SUCCESS",

    GET_MOVEMENT_LIST_REQUEST: "GET_MOVEMENT_LIST_REQUEST",
    GET_MOVEMENT_LIST_SUCCESS: "GET_MOVEMENT_LIST_SUCCESS",
    GET_MOVEMENT_LIST_FAILURE: "GET_MOVEMENT_LIST_FAILURE",

    UPDATE_NEW_MOVEMENT_REQUEST: "UPDATE_NEW_MOVEMENT_REQUEST",
    UPDATE_NEW_MOVEMENT_SUCCESS: "UPDATE_NEW_MOVEMENT_SUCCESS",

    UPDATE_EXISTING_MOVEMENT_REQUEST: "UPDATE_EXISTING_MOVEMENT_REQUEST",
    UPDATE_EXISTING_MOVEMENT_SUCCESS: "UPDATE_EXISTING_MOVEMENT_SUCCESS",

    ADD_NEW_MOVEMENT_REQUEST: "ADD_NEW_MOVEMENT_REQUEST",
    ADD_NEW_MOVEMENT_SUCCESS: "ADD_NEW_MOVEMENT_SUCCESS",
    ADD_NEW_MOVEMENT_FAILURE: "ADD_NEW_MOVEMENT_FAILURE",

    DELETE_MOVEMENT_REQUEST: "DELETE_MOVEMENT_REQUEST",
    DELETE_MOVEMENT_SUCCESS: "DELETE_MOVEMENT_SUCCESS",
    DELETE_MOVEMENT_FAILURE: "DELETE_MOVEMENT_FAILURE",

    PUT_UPDATE_MOVEMENT_REQUEST: "PUT_UPDATE_MOVEMENT_REQUEST",
    PUT_UPDATE_MOVEMENT_SUCCESS: "PUT_UPDATE_MOVEMENT_SUCCESS",
    PUT_UPDATE_MOVEMENT_FAILURE: "PUT_UPDATE_MOVEMENT_FAILURE",

    ADD_NEW_TEMPLATE_REQUEST: "ADD_NEW_TEMPLATE_REQUEST",
    ADD_NEW_TEMPLATE_SUCCESS: "ADD_NEW_TEMPLATE_SUCCESS",

    DELETE_TEMPLATE_REQUEST: "DELETE_TEMPLATE_REQUEST",
    DELETE_TEMPLATE_SUCCESS: "DELETE_TEMPLATE_SUCCESS",

    IMPORT_TEMPLATE_REQUEST: "IMPORT_TEMPLATE_REQUEST",
    IMPORT_TEMPLATE_SUCCESS: "IMPORT_TEMPLATE_SUCCESS"
};

export default actions;
